export * from './shared.module';
export * from './loader/loader.component';



// WEBPACK FOOTER //
// d:/workspace/wynk_web_shoppings_3_prod/src/app/shared/index.ts